// Decorator for auto instance a class and call init method
export function Page() {
  return function (target: any) {
    const instance = new target();
    instance.init();
  };
}
